import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { countryList } from '../data/localData'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
function ServiceMap() {
    return (
        <div className='map-gap common-map'>
            <Container>
                <h2 className='m-0 fs-48 fs-md-35 fs-sm-25 text-center fw-semibold list-title'>Our Global Presence</h2>
                <Row>
                    <Col className='col-12'>
                        <div className='map-holder'>
                            <img src={require('../assets/images/map.png')} alt="" />
                            {
                                countryList.map((country, index) => {
                                    return (
                                        <>
                                            <span
                                                className='point'
                                                key={index}
                                                data-tooltip-id={`my-${country.label}`}
                                                data-tooltip-content={country.label}
                                                data-tooltip-variant="light"
                                                style={{ top: country.top, left: country.left }}
                                            />
                                            <Tooltip
                                                id={`my-${country.label}`}
                                                isOpen={true}
                                                className='fw-bold px-2 py-1 px-md-3 py-md-2 custom-tooltip-map'
                                            />
                                        </>
                                    )
                                })
                            }
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ServiceMap